import { render, staticRenderFns } from "./ToggleCard.vue?vue&type=template&id=795868dc&scoped=true&"
import script from "./ToggleCard.vue?vue&type=script&lang=js&"
export * from "./ToggleCard.vue?vue&type=script&lang=js&"
import style0 from "./ToggleCard.vue?vue&type=style&index=0&id=795868dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795868dc",
  null
  
)

export default component.exports